<template>
  <div class="loca" :class="`set_${change}`">
    <div class="main">
      <p class="main__logo">
        <img src="@/assets/images/main_logo.png" alt="">
      </p>
      <h1 class="main__title">
        <p class="main__subtitle"><span class="left"></span>LOCA는 1+1로 더 큰 혜택<span class="right"></span></p>
        <div class="main__text" v-html="mainText" ref="mainText"></div>
      </h1>
      <div class="main__card">
        <span class="main__classic main-stack"></span>
        <span class="main__plus main-stack"></span>
      </div>
      <div class="main__subcard main-stack">
        <flickity ref="flickity" :options="topSliderOptions" class="main__slider">
          <div class="carousel-cell main__subcard-shopping">
            <span>
              <img src="@/assets/images/main_sub_card_shopping.png" alt="">
            </span>
            <img src="@/assets/images/main_sub_card.png" alt="">
          </div>
          <div class="carousel-cell main__subcard-coffee">
            <span>
              <img src="@/assets/images/main_sub_card_coffee.png" alt="">
            </span>
            <img src="@/assets/images/main_sub_card.png" alt="">
          </div>
          <div class="carousel-cell main__subcard-auto">
            <span>
              <img src="@/assets/images/main_sub_card_auto.png" alt="">
            </span>
            <img src="@/assets/images/main_sub_card.png" alt="">
          </div>
          <div class="carousel-cell main__subcard-edu">
            <span>
              <img src="@/assets/images/main_sub_card_edu.png" alt="">
            </span>
            <img src="@/assets/images/main_sub_card.png" alt="">
          </div>
          <div class="carousel-cell main__subcard-health">
            <span>
              <img src="@/assets/images/main_sub_card_health.png" alt="">
            </span>
            <img src="@/assets/images/main_sub_card.png" alt="">
          </div>
        </flickity>
      </div>
      <div class="main__banner">
        <a :href="bannerUrl">
          <img src="@/assets/images/banner.png" alt="">
        </a>
      </div>
      <span class="main__arrow">
        <img src="@/assets/images/main_icon_arrow.png" alt="">
      </span>
    </div>

    <!-- section2 -->
    <div class="loca__card--container">
      <div class="loca__card--main-container" ref="locaMain">
        <span class="loca__card--main">
          <img v-if="$mq === 'sm'" src="@/assets/images/loca_classic.png" alt="">
          <img v-else src="@/assets/images/loca_classic_pconly.png" alt="">
        </span>
      </div>
      <div class="loca__card loca__card--classic" ref="classic">
        <h2 class="loca__card-title">LOCA CLASSIC으로, <br><strong>최대 1% 할인은 기본</strong></h2>
        <ul class="loca__card-text">
          <li>
            지난달 실적 충족시<span>(150만원 이상)</span>
            <strong>1% 특별 할인</strong>
          </li>
          <li>
            지난달 실적 없이도
            <strong>0.5% 언제나 할인</strong>
          </li>
        </ul>
      </div>
      <!-- section -->
      <div class="loca__card-sub-container" ref="sub">
        <flickity ref="card" :options="cardSliderOptions">
          <div class="loca__card loca__sub loca__sub--shopping">
            <h2 class="loca__card-title">LOCA for Shopping를 더하면, <br><strong>연 최대 60만원 추가할인!</strong></h2>
            <ul class="loca__card-text">
              <li>
                 마트, 온라인쇼핑
                <strong>10% 할인</strong>
              </li>
              <li>
                홈쇼핑, 편의점
                <strong>10% 할인</strong>
              </li>
            </ul>
            <span class="loca__card--sub" v-if="$mq === 'sm'">
              <img src="@/assets/images/loca_sub.png" alt="">
            </span>
          </div>
          <div class="loca__card loca__sub loca__sub--coffee">
            <h2 class="loca__card-title">LOCA for Coffee를 더하면, <br><strong>연 최대 42만원 추가할인</strong></h2>
            <ul class="loca__card-text">
              <li>
                스타벅스, 폴바셋 투썸플레이스 등
                <strong>50%</strong>
              </li>
              <li>
                넷플릭스, 유튜브, 멜론 등
                <strong>20%</strong>
              </li>
            </ul>
            <span class="loca__card--sub" v-if="$mq === 'sm'">
              <img src="@/assets/images/loca_sub.png" alt="">
            </span>
          </div>
          <div class="loca__card loca__sub loca__sub--auto">
            <h2 class="loca__card-title">LOCA for Auto를 더하면, <br><strong>주유 시 리터당 100원 할인!</strong></h2>
            <ul class="loca__card-text">
              <li>
                자동차 보험
                <strong>10,000원 할인</strong>
              </li>
              <li>
                배달앱, 편의점
                <strong>5% 할인</strong>
              </li>
            </ul>
            <span class="loca__card--sub" v-if="$mq === 'sm'">
              <img src="@/assets/images/loca_sub.png" alt="">
            </span>
          </div>
          <div class="loca__card loca__sub loca__sub--edu">
            <h2 class="loca__card-title">LOCA for Edu를 더하면, <br><strong>연 최대 36만원 추가할인!</strong></h2>
            <ul class="loca__card-text">
              <li>
                교육(학원, 학습지, 유치원)
                <strong>5% 할인</strong>
              </li>
              <li>
                서점, 문구점
                <strong>10% 할인</strong>
              </li>
            </ul>
            <span class="loca__card--sub" v-if="$mq === 'sm'">
              <img src="@/assets/images/loca_sub.png" alt="">
            </span>
          </div>
          <div class="loca__card loca__sub loca__sub--health">
            <h2 class="loca__card-title">LOCA for Health를 더하면, <br><strong>연 최대 54만원 추가할인!</strong></h2>
            <ul class="loca__card-text">
              <li>
                병원, 약국, 동물병원
                <strong>10% 할인</strong>
              </li>
              <li>
                백화점, 슈퍼
                <strong>5% 할인</strong>
              </li>
            </ul>
            <span class="loca__card--sub" v-if="$mq === 'sm'">
              <img src="@/assets/images/loca_sub.png" alt="">
            </span>
          </div>
        </flickity>
      </div>
    </div>

    <!-- section3 -->
    <div class="loca__benefit-container">
      <flickity ref="benefit" :options="cardSliderOptions">
        <div class="loca__benefit loca__benefit-01">
          <h2 class="loca__benefit-title">선 넘은 카드, LOCA만의 혜택 <strong>하나!</strong></h2>
          <div class="loca__benefit-inner">
            <h3>세트로
              <strong>실적은 <span>합치고,</span><br>
                혜택은 <span>키우고!</span>
              </strong>
            </h3>
            <p>LOCA + LOCA for Series 세트로 발급하면,<br>
            두 카드 지난달 실적은 합산,<br>
            혜택도 모두 제공</p>
            <p class="small">
              예시)<br>
              LOCA CLASSIC + LOCA for Coffee 발급<br>
              → 두 카드 지난달 실적 합산 150만원 이용 시,<br>
              두 카드 혜택 모두 제공
            </p>
            <span class="loca__benefit-obj">
              <img src="@/assets/images/benefit_obj.jpg" alt="">
            </span>
          </div>
        </div>
        <div class="loca__benefit loca__benefit-02">
          <h2 class="loca__benefit-title">선 넘은 카드, LOCA만의 혜택 <strong>둘!</strong></h2>
          <div class="loca__benefit-inner">
            <h3>
              <strong>신규회원은 <span>카드 2장 모두</span><br>
                <span>연회비 캐시백!</span>
              </strong>
            </h3>
            <p>LOCA + LOCA for Series 세트로 발급하면,<br>
            두 카드 모두 연회비 100% 캐시백!</p>
            <p class="small">
              <strong>대상</strong><br>
              해당 페이지에서 LOCA + LOCA for 세트로<br>
              동시에 신규 발급 받은 회원
            </p>
            <p class="small">
              <strong>캐시백 지급조건</strong><br>
              발급한 LOCA 카드를 ‘롯데카드 라이프’ 앱에 등록 시 제공<br>
              *SET 카드 발급 시 2종의 카드 중 1종의 카드 등록 시에도 지급
            </p>
            <span class="loca__benefit-obj">
              <img src="@/assets/images/benefit_02_obj.jpg" alt="">
            </span>
          </div>
        </div>
      </flickity>
    </div>
    <Footer/>
    <div class="fixed-container">
      <!-- <p class="fixed-container__text" v-if="$route.query.card_category === 'loca'">왼쪽으로 밀어서 혜택을 선택하세요!</p> -->
      <p class="fixed-container__text">지금 선택한 <span>LOCA CLASSIC + LOCA for {{ setFixedBanner.text }}</span></p>
      <ul class="fixed-container__button">
        <li class="fixed-container__item fixed-container__item--black"><a @click="setTrackBenefit" :href="setBenefit(setFixedBanner.linkData.benefit)">세트 혜택 보기</a></li>
        <li class="fixed-container__item fixed-container__item--gold"><a @click="setTrackApply" :href="setBenefit(setFixedBanner.linkData.call)">세트 즉시 신청</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import bidMixin from '@/mixin/bidMixin'

import Footer from '@/components/Footer'
// import Modal from '@/components/Modal'
import Flickity from 'vue-flickity'

import text from '@/constants/text'

export default {
  name: 'Home',
  mixins: [bidMixin],
  components: {
    Flickity,
    // Modal,
    Footer
  },
  data () {
    return {
      mainText:
        `국내외 가맹점 최대 <strong>1% 할인은 기본</strong><br>
        1+1 카드로 <strong class="gold">많이 쓰는 영역에서<br>추가 할인까지</strong>`,
      setFixedBanner: {
        linkData: {
          benefit: null,
          call: null
        },
        text: ''
      },
      topSliderOptions: {
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true
      },
      bid: null,
      cardSliderOptions: {
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true
      },
      card_category: null,
      timelineEnd: false,
      modal: {
        show: false,
        close: false
      }
    }
  },
  computed: {
    change () {
      return this.$route.query.card_category
    },
    setBenefit () {
      return (url) => {
        if (this.$mq === 'sm') {
          url = `https://m.${url}&bId=${this.bid}`
        } else {
          url = `https://www.${url}&bId=${this.bid}`
        }
        return url
      }
    },
    bannerUrl () {
      const url = 'lottecard.co.kr/app/LPBNFDA_V300.lc?evnBultSeq=6254&evnCtgSeq=9999&bigTabGubun=2&bId=13111'
      return this.$mq === 'sm' ? `https://m.${url}` : `https://www.${url}`
    }
  },
  watch: {
    'card_category' (newValue, oldValue) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          card_category: this.switch(newValue)
        }
      }).catch(() => { })
      this.$refs.card.select(newValue)
      this.$refs.flickity.select(newValue)
      this.setView()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (!vm.$route.query.card_category) {
        vm.$router.push({
          query: {
            ...vm.$route.query,
            card_category: 'loca'
          }
        })
      }
    })
  },
  mounted () {
    this.setSlider()
    this.$nextTick(() => {
      this.initialize()
    })
  },
  methods: {
    initialize () {
      const top = document.querySelector('.loca__card-text').offsetTop
      // const cardFront = document.querySelector('.card__front')
      // const cardBack = document.querySelector('.card__back')
      this.$refs.flickity.on('change', (index) => {
        this.card_category = index
      })
      this.$refs.card.on('change', (index) => {
        this.card_category = index
      })
      this.setView()

      const main = this.$gsap.timeline({
        onComplete: () => {
          // this.$nextTick(() => {
          //   const timeLine = this.$gsap.timeline()
          //   timeLine.to('.main__subcard-loca', { opacity: 0 })
          //   timeLine.set('.main__subcard-loca', { display: 'none' })
          //   this.$gsap.to('.main__slider', { opacity: 1 })
          // })
        }
      })
      main.from('.main-stack', {
        opacity: 1,
        y: 100,
        duration: 1,
        stagger: 0.2
      })
      // if (this.$route.query.card_category === 'loca') {
      //   main.add('end')
      //   main.to(cardFront, { rotateY: '-180', duration: 1, ease: 'ease' }, 'end')
      //   main.to(cardBack, { rotateY: '0', duration: 1, ease: 'ease' }, 'end')
      // }

      this.$gsap.fromTo('.main__arrow', {
        opacity: 1,
        y: -5,
        duration: 0.5,
        repeat: -1,
        yoyo: true
      }, {
        opacity: 0.5,
        y: 5,
        duration: 0.5,
        repeat: -1,
        yoyo: true
      })
      if (this.$mq === 'sm') {
        this.$ScrollTrigger.create({
          trigger: this.$refs.classic,
          start: 'top top',
          pin: this.$refs.classic,
          endTrigger: this.$refs.sub,
          end: `top ${top}`,
          pinSpacing: false
        })
        const tl = this.$gsap.timeline({
          scrollTrigger: {
            trigger: this.$refs.classic,
            start: 'top top',
            pin: this.$refs.locaMain,
            endTrigger: this.$refs.sub,
            end: `top ${top}`,
            pinSpacing: false,
            scrub: true
          }
        })
        tl.to(this.$refs.locaMain, { y: '80' })
      }
    },
    modalShow () {
      this.modal.show = true
    },
    modalClose () {
      if (this.modal.show) {
        this.modal.show = false
        return false
      }
    },
    switch (key) {
      switch (key) {
        case 0:
          return 'shopping'
        case 1:
          return 'coffee'
        case 2:
          return 'auto'
        case 3:
          return 'edu'
        case 4:
          return 'health'
        default:
          return 'loca'
      }
    },
    setView () {
      const tl = this.$gsap.timeline()
      tl.fromTo(this.$refs.mainText, { y: 15, autoAlpha: 0 }, { y: 0, autoAlpha: 1 })
      if (this.$route.query.card_category === 'loca') {
        this.mainText = text.shoppingText
        this.setFixedBanner.text = 'Shopping'
        this.setFixedBanner.linkData.benefit = 'lottecard.co.kr/app/LPCDXAD_V100.lc?loca=classic&for=shopping&top=0'
        this.setFixedBanner.linkData.call = 'lottecard.co.kr/app/LPCDXAA_V100.lc?vtCdKndC=P13379-A13379&vtCdKndC_sec=P13395-A13395'
      }
      if (this.$route.query.card_category === 'coffee') {
        this.mainText = text.coffeeText
        this.setFixedBanner.text = 'Coffee'
        this.setFixedBanner.linkData.benefit = 'lottecard.co.kr/app/LPCDXAD_V100.lc?loca=classic&for=coffee&top=0'
        this.setFixedBanner.linkData.call = 'lottecard.co.kr/app/LPCDXAA_V100.lc?vtCdKndC=P13379-A13379&vtCdKndC_sec=P13391-A13391'
      }
      if (this.$route.query.card_category === 'auto') {
        this.mainText = text.autoText
        this.setFixedBanner.text = 'Auto'
        this.setFixedBanner.linkData.benefit = 'lottecard.co.kr/app/LPCDXAD_V100.lc?loca=classic&for=auto&top=0'
        this.setFixedBanner.linkData.call = 'lottecard.co.kr/app/LPCDXAA_V100.lc?vtCdKndC=P13379-A13379&vtCdKndC_sec=P13399-A13399'
      }
      if (this.$route.query.card_category === 'edu') {
        this.mainText = text.eduText
        this.setFixedBanner.text = 'Edu'
        this.setFixedBanner.linkData.benefit = 'lottecard.co.kr/app/LPCDXAD_V100.lc?loca=classic&for=edu&top=0'
        this.setFixedBanner.linkData.call = 'lottecard.co.kr/app/LPCDXAA_V100.lc?vtCdKndC=P13379-A13379&vtCdKndC_sec=P13403-A13403'
      }
      if (this.$route.query.card_category === 'health') {
        this.mainText = text.healthText
        this.setFixedBanner.text = 'Health'
        this.setFixedBanner.linkData.benefit = 'lottecard.co.kr/app/LPCDXAD_V100.lc?loca=classic&for=health&top=0'
        this.setFixedBanner.linkData.call = 'lottecard.co.kr/app/LPCDXAA_V100.lc?vtCdKndC=P13379-A13379&vtCdKndC_sec=P13407-A13407'
      }
      if (this.$route.query.card_category === 'shopping') {
        this.mainText = text.shoppingText
        this.setFixedBanner.text = 'Shopping'
        this.setFixedBanner.linkData.benefit = 'lottecard.co.kr/app/LPCDXAD_V100.lc?loca=classic&for=shopping&top=0'
        this.setFixedBanner.linkData.call = 'lottecard.co.kr/app/LPCDXAA_V100.lc?vtCdKndC=P13379-A13379&vtCdKndC_sec=P13395-A13395'
      }
    },
    setSlider () {
      if (!this.timelineEnd) {
        if (this.$route.query.card_category === 'loca') {
          this.$refs.card.select(0, false, true)
          this.$refs.flickity.select(0, false, true)
        }
        if (this.$route.query.card_category === 'coffee') {
          this.$refs.card.select(1, false, true)
          this.$refs.flickity.select(1, false, true)
        }
        if (this.$route.query.card_category === 'auto') {
          this.$refs.card.select(2, false, true)
          this.$refs.flickity.select(2, false, true)
        }
        if (this.$route.query.card_category === 'edu') {
          this.$refs.card.select(3, false, true)
          this.$refs.flickity.select(3, false, true)
        }
        if (this.$route.query.card_category === 'health') {
          this.$refs.card.select(4, false, true)
          this.$refs.flickity.select(4, false, true)
        }
        if (this.$route.query.card_category === 'shopping') {
          this.$refs.card.select(0, false, true)
          this.$refs.flickity.select(0, false, true)
        }
      }
    },
    setTrackBenefit () {
      if (this.$mq !== 'sm') {
        this.$gtag.event('LOCA_PC_SET혜택보기', {
          event_category: 'pc_set_detail', event_action: 'click', event_label: 'pc_loca'
        })
        window.Emf.convCall(916, 5681, 0, 'LOCA_PC', 'set_detail')
      } else {
        this.$gtag.event('LOCA_MO_SET혜택보기', {
          event_category: 'mo_set_detail', event_action: 'click', event_label: 'mo_loca'
        })
        window.kakaoPixel('811034772343273332').pageView()
        window.kakaoPixel('811034772343273332').viewContent({
          tag: 'set_detail'
        })
        window.fbq('track', 'gate_loca_set_detail')
        window.Emf.convCall(916, 5682, 0, 'LOCA_MO', 'set_detail')
      }
    },
    setTrackApply () {
      if (this.$mq !== 'sm') {
        this.$gtag.event('LOCA_PC_SET즉시신청', {
          event_category: 'pc_set_application', event_action: 'click', event_label: 'pc_loca'
        })
        window.Emf.convCall(916, 5681, 0, 'LOCA_PC', 'set_application')
      } else {
        this.$gtag.event('LOCA_MO_SET즉시신청', {
          event_category: 'mo_set_application', event_action: 'click', event_label: 'mo_loca'
        })
        window.kakaoPixel('811034772343273332').pageView()
        window.kakaoPixel('811034772343273332').viewContent({
          tag: 'set_application'
        })
        window.fbq('track', 'gate_loca_set_application')
        window.Emf.convCall(916, 5682, 0, 'LOCA_MO', 'set_application')
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/main.scss';
</style>
